export enum EPaths {
    MANAGEMENT = 'management',
    INSTANCE_MANAGEMENT = 'instance_management',
    USER_MANAGEMENT = 'user-management',
    USER_DETAIL = 'user-detail',
    INSTANCE_UPDATE='instance_update',
    INSTANCE_DETAIL = 'instance-detail',
    CREATE_USER = 'create-user',
    MY_PROFILE = 'my-profile',
}